import React, { FC } from "react";
import { Helmet } from "./Helmet";

export const ZoomDisabled: FC = () => {
  return (
    <Helmet>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
    </Helmet>
  );
};
